import { PHOTOS_GET } from '../Api';
import createAsyncSlice from './helper/createAsyncSlice';

const slice = createAsyncSlice({
  name: 'feed2',
  initialState: {
    list: [],
    pages: 1,
    avatar: [],
    userfeed: {},
    links: [],
    category: 0,
    favorite: 0,
    infinite: true,
  },
  reducers: {
    addPhotos(state, action) {
      state.list.push(...action.payload.data);
      state.userfeed = {...action.payload.user};
      state.avatar = [{...action.payload.avatar}];
      state.links = [...action.payload.meta.links];
      if (action.payload.length === 0) state.infinite = false;
    },
    searchbyLinks(state, action) {

      console.log('em links');
      const data = action.payload.data;
      const bylinks = data?.filter(({ link }) => link != null);
      state.pages = 0;
      state.list.push(...bylinks);
      state.userfeed = {...action.payload.user};
      state.avatar = [{...action.payload.avatar}];
      state.links = [...action.payload.meta.links];
      //if (action.payload.length === 0) state.infinite = false;
      state.infinite = false;
    },
    searchbyVideos(state, action) {

      console.log('em videos');
      const data = action.payload.data;
      const byvideos = data?.filter(({ video }) => video != null);
      state.pages = 0;
      state.list.push(...byvideos);
      state.userfeed = {...action.payload.user};
      state.avatar = [{...action.payload.avatar}];
      state.links = [...action.payload.meta.links];
      //if (action.payload.length === 0) state.infinite = false;
      state.infinite = false;
    },
    addPage(state) {
      state.pages++;
    },
    setCategory(state,cat) {
      state.category = cat.payload;
    },
    setFavorito(state,fav) {
      state.favorite = fav.payload;
    },
    disableInfinite(state) {
      state.infinite = false;
    },    
    setPage(state,page) {
      state.pages = page;
    },
    resetState(state) {
      state.infinite = true;
      state.pages = 1;
      state.list = [];
      state.data = null;
      state.error = null;
      state.loading = false;
    },
  },
  fetchConfig: ({ page, total, user, key, category, favorite }) => PHOTOS_GET({ page, total, user, key, category, favorite}),
});

export const fetchFeed = slice.asyncAction;
export const { addPhotos, addPage, setCategory, setFavorito, disableInfinite, searchbyVideos, searchbyLinks, setPage, resetState: resetFeedState } = slice.actions;

export const loadNewPhotos = ({ total = 8, user, key, links, videos, category, favorite }) => async (
  dispatch,
  getState,
) => {
  const { feed2 } = getState();
  if (!links || !videos) dispatch(addPage());
  const { payload } = await dispatch(
    fetchFeed({ page: feed2.pages, total, user, key, category: feed2.category, favorite: feed2.favorite }),
  );
  if (links) {
    dispatch(searchbyLinks(payload));
  } else if (videos) {
    dispatch(searchbyVideos(payload));
  } else {
  dispatch(addPhotos(payload));
  }
};

export const loadAll = ({ total = 8, user, key, links, videos, category, favorite }) => async (
  dispatch,
  getState,
) => {
  const { feed2 } = getState();
  if (!links || !videos) dispatch(addPage());
  const { payload } = await dispatch(
    fetchFeed({ page: feed2.pages, total, user, key, category: feed2.category, favorite: feed2.favorite }),
  );
  console.log(payload);
  if (links) {
    dispatch(searchbyLinks(payload));
  } else if (videos) {
    dispatch(searchbyVideos(payload));
  } else {
  dispatch(addPhotos(payload));
  }
};


export default slice.reducer;
